import React, { useMemo } from 'react';
import { AgGauge } from 'ag-charts-react';
import { useSelector } from 'react-redux';
import merge from 'lodash/merge';
import { useDatasourceData } from '../../hooks/useDatasourceData.js';
import { useDatasource } from '../../hooks/useDatasource.js';

function GaugeWidget({widgetId, widgetRef, theme, widgetHeight}) {
  const gaugeOptions = useSelector(state => state.dashboard.widgets[widgetId].settings?.gaugeOptions || {});
  const { rows: filteredRows } = useDatasourceData(widgetId);

  useDatasource({ widgetId, live: true });
  
  // Needed for height calculation. Should probably do a custom hook with this and the widgetHeight
  const globalPadding = useSelector(state => state.dashboard.theme?.background?.padding);
  const overrideTopPadding = theme?.overrides?.common?.padding?.top;
  const borderWidth = theme?.params?.borderWidth || 0

  const options = useMemo(() => {
    const getNum = (src, key, fallback = 0) => typeof key === 'number' ? key : Number(src?.[key] ?? fallback);
    
    const { datasource = {}, ...rest } = gaugeOptions;
    const r0 = filteredRows?.[0] ?? {};

    const value = getNum(r0, datasource.value, 0);
    const min = getNum(r0, datasource.scale?.min, 0);
    const max = getNum(r0, datasource.scale?.max, 100);
    const {items = [], ...targetsRest} = datasource.targets || {};
    const targets = items.map(r => ({
      ...targetsRest,
      value: getNum(r0, r?.value, undefined),
      text: r?.text ?? ''
    }));

    // Gauge API doesn't fully ignore disabled configs (e.g. label.enabled: false still overrides by showing empty label in place of value)
    // So we strip out any objects with enabled: false before merging
    const filtered = Object.fromEntries(
      Object.entries(rest).filter(([_, v]) => !(v && v.enabled === false))
    );

    return merge(
      {height: parseInt(widgetHeight, 10) - (overrideTopPadding || globalPadding || 0) - borderWidth * 2 || 0},
      { value, scale: { min, max }, targets },
      filtered
    );
  }, [gaugeOptions, filteredRows, widgetHeight, theme]);

  return (
    <div style={{ height: '100%', width: '100%', position: 'relative' }}>
      <AgGauge 
        options={options} 
      />
    </div>
  )
}

export default GaugeWidget;
